/**
 * Created by r4zi4l on 11.11.2021
 */

const Orders = function (options) {
    cleverapps.EventEmitter.call(this);

    this._maker = options && options.maker || Map2d.currentMap.customers.findReady() || Map2d.currentMap.customers.findCanCook() || Map2d.currentMap.customers.listCustomersWithRecipe()[0];

    Map2d.currentMap.customers.on("onUpdateOrder", this.updateOrder.bind(this), this);
    Map2d.currentMap.customers.on("onRecipesUpdated", this.updateOrder.bind(this), this);
};
Orders.prototype = Object.create(cleverapps.EventEmitter.prototype);
Orders.prototype.constructor = Orders;

Orders.prototype.updateOrder = function (maker) {
    this.trigger("orderStateChanged", maker);
};

Orders.prototype.selectMaker = function (maker) {
    this.trigger("makerSelected", maker);
};

Orders.prototype.scrollToSelectedOrderByMaker = function () {
    this.trigger("scrollToSelected", this._maker);
};

Orders.prototype.cook = function (maker) {
    const cook = () => {
        this.trigger("ingredientsConsumed", maker);
        maker.cook();
        this.trigger("ingredientsUpdated", maker);
        cleverapps.eventBus.trigger("taskEvent", "MAKE_ORDER");
    };

    if (typeof HungryGamesCustomer !== "undefined" && maker.unit.findComponent(HungryGamesCustomer)) {
        const window = cleverapps.focusManager.currentWindow();
        if (window) {
            window.close();
        }

        Map2dScroller.currentScroller.scrollToUnit(0.5, maker.unit, { callback: cook });
        return;
    }

    cook();
};

Orders.prototype.processOrder = function (maker, skipBuyWindow) {
    if (maker.getState() === Customer.STATE_RECIPE) {
        if (!maker.canCook()) {
            if (skipBuyWindow) {
                this.buyIngredients(maker.recipe.getShoppingList(), this.cook.bind(this, maker));
            } else {
                cleverapps.focusManager.display({
                    focus: "BuyIngredientsWindow",
                    stack: true,
                    action: (f) => {
                        new BuyIngredientsWindow(maker.recipe.getShoppingList(), this.cook.bind(this, maker), this);
                        cleverapps.focusManager.onceNoWindowsListener = f;
                    }
                });
            }
            return;
        }

        this.cook(maker);
    } else if (maker.getState() === Customer.STATE_COOKING) {
        maker.enjoy();
        this.trigger("orderClaimed", maker);
    } else if (maker.getState() === Customer.STATE_READY) {
        this.trigger("orderClaimed", maker);
    }
};

Orders.prototype.getShoppingListDetails = function (shoppingList) {
    return {
        ingredients: shoppingList.softItems.concat(shoppingList.hardItems),
        totalHard: shoppingList.totalHard,
        totalSoft: shoppingList.totalSoft
    };
};

Orders.prototype.getBuyIngredientsText = function (maker) {
    const { totalHard, totalSoft } = this.getShoppingListDetails(maker.recipe.getShoppingList());
    let result = Messages.get("OrdersWindow.button.buyingredients");
    if (cleverapps.config.name === "mergecraft") {
        result += (totalSoft ? ` @@${totalSoft}` : "") + (totalHard ? ` $$${totalHard}` : "");
    }
    return result;
};

Orders.prototype.buyIngredients = function (shoppingList, onSuccess) {
    onSuccess = onSuccess || function () {};

    const { ingredients, totalHard, totalSoft } = this.getShoppingListDetails(shoppingList);

    if (!Map2d.currentMap.stock.canSpawnIngredients(ingredients)) {
        return;
    }

    if (totalHard && !cleverapps.user.canTakeHard(totalHard)) {
        cleverapps.user.onCantTakeGold(totalHard - cleverapps.user.gold);
        return;
    }

    if (totalSoft && !cleverapps.user.canTakeSoft(totalSoft)) {
        cleverapps.user.onCantTakeSoft();
        return;
    }

    if (totalHard) {
        cleverapps.user.spendHard(cleverapps.EVENTS.SPENT.RECIPE_INGREDIENT_ALL, totalHard);
    }

    if (totalSoft) {
        cleverapps.user.spendSoft(cleverapps.EVENTS.SPENT.RECIPE_INGREDIENT_ALL, totalSoft);
    }

    Map2d.currentMap.stock.spawnIngredients(ingredients);
    onSuccess();
};

Orders.prototype.getCurrentMaker = function () {
    return this._maker;
};

Orders.prototype.destructor = function () {
    runCleaners(this);
};